/* ============================================================
   Zina Tahiri - Judge.me review enhancements (DRAFT THEME ONLY)
   Loaded on product pages via sections/main-product.liquid.

   Uses the live review data Judge.me embeds in the page
   (window.jdgm.data.reviewWidget[productId]): number_of_reviews,
   average_rating, and the 5->1 histogram. Nothing is invented;
   if a product has no review data, nothing renders.

   1. Compact rating snippet under the product title
      (stars + rating + clickable review count -> #zt-reviews).
   2. Compact widget summary built from live data:
      5.0 ***** 125 reviews (widget's native summary hidden).
   3. 5->1 star distribution bars above the reviews.

   IMPORTANT: All widget-DOM queries are scoped to
   #judgeme_product_reviews so theme-level elements (like the
   under-title snippet) are never touched.
   ============================================================ */
(function () {
  'use strict';

  function getWidget() {
    return document.getElementById('judgeme_product_reviews');
  }

  function getReviewData() {
    var snip = document.querySelector('.zt-rating-snippet');
    var pid = snip && snip.getAttribute('data-product-id');
    var widget = getWidget();
    if (!pid && widget) {
      pid = widget.getAttribute('data-product-id') || widget.getAttribute('data-id');
    }
    if (!pid || !window.jdgm || !jdgm.data || !jdgm.data.reviewWidget) return null;
    return jdgm.data.reviewWidget[pid] || jdgm.data.reviewWidget[String(pid)] || null;
  }

  function starRow(filledCount, cls) {
    var html = '<span class="' + (cls || 'zt-stars') + '" aria-hidden="true">';
    for (var i = 1; i <= 5; i++) {
      html += '<span class="zt-star' + (i <= filledCount ? ' is-filled' : '') + '">&#9733;</span>';
    }
    return html + '</span>';
  }

  /* ---- 1. Under-title snippet ---- */
  function renderSnippet(data) {
    var snip = document.querySelector('.zt-rating-snippet');
    if (!snip) return;
    var existing = snip.querySelector('.zt-rating-num');
    if (existing && existing.textContent.trim()) return; // already rendered
    if (!data || !data.number_of_reviews) {
      snip.style.display = 'none';
      snip.dataset.done = '1';
      return;
    }
    var avg = parseFloat(data.average_rating);
    var avgDisplay = avg.toFixed(1);
    var count = data.number_of_reviews;
    snip.innerHTML =
      '<a href="#zt-reviews" class="zt-rating-jump" aria-label="Jump to customer reviews">' +
      starRow(Math.round(avg)) +
      '<span class="zt-rating-num">' + avgDisplay + '</span>' +
      '<span class="zt-rating-count">' + count + (count === 1 ? ' review' : ' reviews') + '</span>' +
      '</a>';
    snip.dataset.done = '1';
  }

  /* ---- 2. Compact widget summary (built from data; native hidden) ---- */
  function compactSummary(data) {
    var h2 = document.getElementById('zt-reviews');
    if (!h2 || h2.dataset.compactDone || !data || !data.number_of_reviews) return;
    var widget = getWidget();
    if (!widget) return;

    var avgNum = parseFloat(data.average_rating);
    var avgDisplay = avgNum.toFixed(1);
    var count = data.number_of_reviews;

    // Build our own compact summary from live data (outside Vue's tree)
    var wrap = document.createElement('div');
    wrap.className = 'zt-compact-summary';
    wrap.innerHTML =
      '<span class="zt-sum-avg">' + avgDisplay + '</span>' +
      starRow(Math.round(avgNum)) +
      '<span class="zt-sum-count">' + count + (count === 1 ? ' review' : ' reviews') + '</span>';
    h2.after(wrap);

    // Hide the widget's native summary elements (scoped to widget only).
    hideNativeSummary(widget);

    h2.dataset.compactDone = '1';

    // Vue re-renders discard our wrappers (e.g. on scroll). Re-apply
    // hiding whenever the widget's DOM changes.
    if (!widget.dataset.ztObserved) {
      widget.dataset.ztObserved = '1';
      var obs = new MutationObserver(function () {
        hideNativeSummary(widget);
      });
      obs.observe(widget, { childList: true, subtree: true });
    }
  }

  /* Hide widget-native "5.0" / "125 reviews" / header stars.
     Scoped to #judgeme_product_reviews. Idempotent. */
  function hideNativeSummary(widget) {
    if (!widget) return;
    // Header stars: first .jm-star-rating inside the widget.
    var stars = widget.querySelectorAll('.jm-star-rating');
    if (stars.length && !stars[0].closest('.zt-compact-summary')) {
      stars[0].style.display = 'none';
    }
    // Native summary text nodes: wrap in hidden spans.
    var walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
    var node;
    var toHide = [];
    while ((node = walker.nextNode())) {
      var t = node.textContent.trim();
      if (!t) continue;
      var pe = node.parentElement;
      if (!pe) continue;
      // Skip buttons, selects, our own elements, and already-hidden nodes
      if (pe.closest('button, select, .zt-compact-summary, .zt-histogram')) continue;
      if (pe.closest('[data-zt-hidden]')) continue;
      if (/^\d+(\.\d+)?$/.test(t) || /^\d+\s*reviews?$/i.test(t) ||
          /^\d+(\.\d+)?\s+\d+\s*reviews?$/i.test(t)) {
        toHide.push(node);
      }
    }
    toHide.forEach(function (n) {
      if (!n.parentElement) return;
      var hide = document.createElement('span');
      hide.style.display = 'none';
      hide.setAttribute('aria-hidden', 'true');
      hide.setAttribute('data-zt-hidden', '1');
      n.parentElement.replaceChild(hide, n);
      hide.appendChild(n);
    });
  }

  /* ---- 3. Distribution bars above the reviews ---- */
  function renderHistogram(data) {
    var h2 = document.getElementById('zt-reviews');
    if (!h2 || h2.dataset.histDone) return;
    if (!data || !data.histogram || !data.histogram.length) return;
    var total = data.histogram.reduce(function (s, h) {
      return s + (h.frequency || 0);
    }, 0);
    if (!total) return;

    var html = '<div class="zt-histogram" role="img" aria-label="Rating distribution">';
    data.histogram.forEach(function (h) {
      var pct = h.percentage || 0;
      html +=
        '<div class="zt-hist-row">' +
        '<span class="zt-hist-label">' + h.rating + ' <span class="zt-star is-filled">&#9733;</span></span>' +
        '<span class="zt-hist-track"><span class="zt-hist-fill" style="width:' + pct + '%"></span></span>' +
        '<span class="zt-hist-count">' + (h.frequency || 0) + '</span>' +
        '</div>';
    });
    html += '</div>';

    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var histEl = tmp.firstChild;

    // Insert right after the widget's header (above the review list).
    // Falls back to after our compact summary.
    var widget = getWidget();
    var widgetHeader = widget && widget.querySelector('.jm-review-widget-minimal-header');
    if (widgetHeader && widgetHeader.parentElement) {
      widgetHeader.after(histEl);
    } else {
      var wrap = document.querySelector('.zt-compact-summary');
      if (wrap) wrap.after(histEl);
      else h2.after(histEl);
    }
    h2.dataset.histDone = '1';
  }

  function init() {
    var data = getReviewData();
    renderSnippet(data);
    if (data && document.getElementById('zt-reviews')) {
      compactSummary(data);
      renderHistogram(data);
    }
  }

  // Judge.me embeds its data synchronously, but the widget DOM renders
  // asynchronously — poll briefly until everything is in place.
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    try {
      init();
    } catch (e) {
      /* noop */
    }
    var h2 = document.getElementById('zt-reviews');
    var snip = document.querySelector('.zt-rating-snippet');
    var done = h2 && h2.dataset.compactDone && h2.dataset.histDone && snip && snip.dataset.done;
    if (done || tries > 40) clearInterval(timer);
  }, 500);
})();
